<template>
  <div :class="`hourly-item-value ${classItemValue}`">
    <v-icon v-if="tag && (greatestValue || tag === 'same')" color="#339CB9"> mdi-arrow-up</v-icon>
    <v-icon v-if="tag && (smallestValue || tag === 'same')" color="#D96CBC"> mdi-arrow-down</v-icon>
    <span v-if="tag && tagValue" :key="`span-${hourKey}-${index}`">
        {{tagValue}}
    </span>
    <span v-else :key="`span-${hourKey}-${index}`">
        {{ showNormalValue(item[`hour${hourKey}Value`]) }}
    </span>
  </div>
</template>

<script>
import moment from "moment-timezone";
export default {
    name: "HourlySensorValueTable",
    props: ["highlightsCards", "item", "hourKey", "index"],
    data: () => ({
        tag: undefined,
        sensorDescription: undefined,
        tagValue: undefined,
    }),

    created(){
        this.initialize();
    },

    watch:{
        item(value){
            if(value){
                this.initialize();
            }
        },
        highlightsCards(value){
            if(value){
                this.initialize();
            }
        }
    },

    computed:{
        classItemValue(){
            if(this.tag && this.tag === 'min') return 'smallest-hourly-item-value';
            if(this.tag && this.tag === 'max') return 'greatest-hourly-item-value';
            return "";
        },

        greatestValue(){
            return this.tag && this.tag === "max";
        },

        smallestValue(){
            return this.tag && this.tag === "min";
        }
    },

    methods:{
        initialize(){
            const findResult = this.itemHasTag(this.item.dateIso, this.item[`hour${this.hourKey}Id`], this.hourKey);
            if(findResult){
                const { tag, sensor, value } = findResult;
                this.tag = tag;
                this.sensorDescription = sensor.descricao;
                this.tagValue = value;
            }else{
                this.tag = undefined;
                this.sensorDescription = undefined;
                this.tagValue = undefined;
            }
        },

        itemHasTag(itemDate, itemSensorId, hourKey){
            const date = moment.tz(`${itemDate} ${hourKey}:00`, "America/Sao_Paulo").utc();
            const findResult = this.highlightsCards.find((result) => {
                    const { datahora, tag, sensorId } = result;
                    return moment(datahora).utc().isSame(date, "hour") && itemSensorId == sensorId && tag;
                });
            return findResult;
        },

        showNormalValue(value){
            return value ? value : value === 0 ? Number(value).toFixed(1) :  "--";
        }
    }
}
</script>

<style scoped>

    .hourly-item-value{
        width: 100%; 
        height:100%;
        margin: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .greatest-hourly-item-value{
        background-color: rgba(51, 156, 185, 0.2);
        color: #339CB9;
    }

    .smallest-hourly-item-value{
        background-color: rgba(217, 108, 188, 0.2);
        color: #D96CBC;
    }

</style>